var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-contact-container bg-light-grey" }, [
    _c(
      "div",
      { staticClass: "footer-contact", class: [_vm.schema.settings.textColor] },
      [
        _vm.enabledSocial.length > 0
          ? _c("div", { staticClass: "footer-contact__social" }, [
              _c(
                "div",
                { staticClass: "footer-contact__social-list" },
                _vm._l(_vm.enabledSocial, function(social) {
                  return _c(
                    "a",
                    {
                      key: social.id,
                      staticClass: "footer-contact__social-link",
                      attrs: {
                        href: social.url,
                        target: "_blank",
                        "aria-label": social.id
                      }
                    },
                    [
                      _c("icon", {
                        staticClass: "footer-contact__social-icon",
                        attrs: {
                          name: social.id,
                          fillClass: _vm.schema.settings.socialIconColor,
                          size: "24px"
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }